<template>
  <div class="admin-page admin-page--centered">
    <div class="admin-page-inner admin-page-inner--compact">
      <section class="admin-panel mt-10">
        <div class="admin-panel__body py-14">
          <i class="fa fa-shield-halved mb-5 text-4xl text-caspyellow" aria-hidden="true"></i>
          <h1 class="admin-page-title">Admin Center</h1>
          <p class="admin-page-subtitle mt-3">
            Wählen Sie links einen Bereich aus, um fortzufahren.
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminCenter",
  created() {
    document.getElementById("mainspinner").style.display = "none";
    if (localStorage) localStorage.setItem("last", "/admin");
  },
};
</script>
